// src/components/PreviewPage.jsx
import React, { useState, useEffect } from "react";
import { Loader, Copy, ExternalLink, X } from "lucide-react";

import { renderPreviewComponent } from "./utils/renderPreviewComponent";
import EnlargedImageModal from "./components/ui/EnlargedImageModal"; // 👈 引入独立的放大组件

import { API_BASE } from "./api/config";

export const PreviewPage = ({ previewId }) => {
  const [previewComponents, setPreviewComponents] = useState(null);
  const [loadingPreview, setLoadingPreview] = useState(true);
  const [previewError, setPreviewError] = useState(null);
  const [enlargedImage, setEnlargedImage] = useState(null);
  const [pageTitle, setPageTitle] = useState("");

  useEffect(() => {
    // 一进入页面就设置临时标题
    document.title = "加载中...";

    const loadPreview = async () => {
      try {
        const res = await fetch(
          `${API_BASE}/preview.php?id=${encodeURIComponent(previewId)}`,
        );
        if (res.ok) {
          const data = await res.json();
          // ✅ 正确提取
          setPageTitle(data.title || "");
          if (Array.isArray(data.components)) {
            setPreviewComponents(data.components);
          } else {
            throw new Error("数据格式错误");
          }
        } else {
          const errorData = await res.json().catch(() => ({}));
          throw new Error(errorData.error || "页面加载失败");
        }
      } catch (err) {
        console.error("预览加载失败:", err);
        setPreviewError(err.message || "未知错误");
      } finally {
        setLoadingPreview(false);
      }
    };

    if (previewId) loadPreview();
  }, [previewId]);

  // 在 import 之后、组件内部添加
  useEffect(() => {
    console.log("预览组件数据:", pageTitle);
    if (previewComponents) {
      document.title = pageTitle;
    }
  }, [previewComponents]);

  if (loadingPreview) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <Loader className="w-8 h-8 text-blue-600 animate-spin mx-auto mb-2" />
          <p className="text-gray-600">加载页面中...</p>
        </div>
      </div>
    );
  }

  if (previewError) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="text-2xl font-bold text-red-600 mb-4">加载失败</div>
          <p className="text-gray-600 mb-6">{previewError}</p>
          <button
            onClick={() => (window.location.href = "/")}
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition-colors"
          >
            返回首页
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full bg-white rounded-2xl shadow-xl p-3">
        <div className="space-y-6">
          {previewComponents?.map((component, index) => (
            <div key={index} className="text-center">
              {renderPreviewComponent(component, setEnlargedImage)}
            </div>
          ))}
        </div>
      </div>

      {/* 调用封装好的完美模态框组件 */}
      <EnlargedImageModal 
        src={enlargedImage} 
        onClose={() => setEnlargedImage(null)} 
      />
    </div>
  );
};
